import classNames from "classnames/bind";
import styles from "../../styles/info/Range.module.css";
import insuranceData from "../../data/insurance.json";

const cx = classNames.bind(styles);

export default function Range() {
  return (
    <section className={cx("rangeWrap")}>
      <div className={cx("title")}>
        <h4>손해사정 업무범위</h4>
      </div>
      <div className={cx("rangeList")}>
        {insuranceData.insurances.map((item, index) => (
          <div key={index} className={cx("rangeItem", "reveal")}>
            <div className={cx("rangeImgBox")}>
              <div className={cx("imgInner")}>
                <img src={item.img} alt={item.title} />
              </div>
            </div>

            <div className={cx("rangeTextBox")}>
              <h5>{item.title}</h5>
              <p>{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
